import styled, { css } from 'foundations-theming-specialty/utils';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { USER_INVITE_MODAL_COMPONENT } from 'navigation-components/config';
import TrackedLink from '../TrackedLink';
import useMenuItem from '../Menu/hooks/useMenuItem';
import { usePortal, useTranslation } from '../../hooks/useNavConfig';
import { getTypographyStyles } from 'breadcrumbs-ui/components/Text';
import { getAccountMenuItemPadding, getAccountMenuBorder } from './shared-styles';
import { useIsUngated } from '../../hooks/useIsUngated';
import { PLPO_GATE, USER_INVITE_MODAL_GATE } from '../../constants/gates';
import usePLPOData from '../../hooks/usePLPOData';
import { withErrorBoundary } from '../ErrorBoundary';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenuItem = styled.li.withConfig({
  displayName: "InviteLink__StyledMenuItem",
  componentId: "sc-1a674nk-0"
})(({
  theme
}) => css(["list-style-type:none !important;border-bottom:", " !important;position:relative;button,a{position:relative;background-color:transparent;max-width:290px;color:", " !important;", " border:0;margin:0;width:100%;padding:", " !important;text-decoration:none;text-align:left;display:flex;align-items:center;&:hover,&:focus{text-decoration:underline !important;}& > svg{margin-right:8px !important;fill:", ";}}"], getAccountMenuBorder(theme), theme.color['text-core-default'], getTypographyStyles(theme, 'body-125'), getAccountMenuItemPadding(theme), theme.color['icon-core-subtle']));
const _InviteLink = () => {
  const {
    t
  } = useTranslation();
  const {
    portalId
  } = usePortal();
  const {
    menuItemId,
    setRef,
    onMenuItemKeyDown,
    tabIndex
  } = useMenuItem({
    id: 'navInviteLink'
  });
  const {
    toggle
  } = useToggleComponent(USER_INVITE_MODAL_COMPONENT);
  const {
    isEligible,
    isFetching
  } = usePLPOData();
  const isUngatedToPLPO = useIsUngated(PLPO_GATE);
  const isUngatedToUserInviteModal = useIsUngated(USER_INVITE_MODAL_GATE);
  const showInviteModal = isUngatedToUserInviteModal || isUngatedToPLPO && isEligible;
  const inviteProps = showInviteModal ? {
    onClick: () => toggle(true)
  } : {
    href: `/settings/${portalId}/users/add?via=account-menu`
  };
  return /*#__PURE__*/_jsx(StyledMenuItem, {
    role: "menuitem",
    children: /*#__PURE__*/_jsxs(TrackedLink, Object.assign({}, inviteProps, {
      id: menuItemId,
      ref: setRef,
      onKeyDown: onMenuItemKeyDown,
      tabIndex: tabIndex,
      "data-test-id": "nav-account-invite-link",
      "data-test-fetching": isFetching,
      children: [/*#__PURE__*/_jsx(ListsIcon, {
        size: "300"
      }), t(showInviteModal ? 'nav.inviteModal.text' : 'nav.inviteLink.text')]
    }))
  });
};
export const InviteLink = withErrorBoundary(memoWithDisplayName('InviteLink', _InviteLink), {
  boundaryName: 'InviteLink'
});